const BASE_URL = 'https://www.diamondcars.pt';

const setOrCreate = (selector, attr, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [a, v] = attr.split('=');
    el.setAttribute(a, v.replace(/"/g, ''));
    document.head.appendChild(el);
  }
  el.content = value;
};

export const setPageMeta = ({ title, description, path = '', image = '/logo-white.svg' }) => {
  const fullTitle = title ? `${title} | Diamond Cars` : 'Diamond Cars | Viaturas Usadas em Ovar';
  const url = `${BASE_URL}${path}`;
  const imgUrl = image.startsWith('http') ? image : `${BASE_URL}${image}`;

  document.title = fullTitle;

  setOrCreate('meta[name="description"]', 'name=description', description);
  setOrCreate('meta[name="robots"]', 'name=robots', 'index, follow');

  // Canonical
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = url;

  // Open Graph
  setOrCreate('meta[property="og:title"]', 'property=og:title', fullTitle);
  setOrCreate('meta[property="og:description"]', 'property=og:description', description);
  setOrCreate('meta[property="og:url"]', 'property=og:url', url);
  setOrCreate('meta[property="og:image"]', 'property=og:image', imgUrl);
  setOrCreate('meta[property="og:type"]', 'property=og:type', 'website');
  setOrCreate('meta[property="og:locale"]', 'property=og:locale', 'pt_PT');
  setOrCreate('meta[property="og:site_name"]', 'property=og:site_name', 'Diamond Cars');


};
